import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "sign_up",
  class: "mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "partner_id"
}, "Partner ID", -1)
const _hoisted_5 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "website"
}, [
  /*#__PURE__*/_createTextVNode(" Website "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7" }, "(optional)")
], -1)
const _hoisted_7 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_first_name"
}, " Your first name ", -1)
const _hoisted_9 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_last_name"
}, "Your last name", -1)
const _hoisted_11 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_phone"
}, " Your cell phone number ", -1)
const _hoisted_13 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "contact_email"
}, "Your email", -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_18 = { class: "d-grid" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-center fs-8 text-decoration-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://getakko.com/legal",
    target: "_blank"
  }, "Terms and Conditions")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, { css: "signup-form" }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.validationSchema
      }, {
        default: _withCtx(({ errors, meta, isSubmitting, setFieldValue }) => [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'partner_id')]),
                  name: "partner_id",
                  id: "partner_id",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "partner_id"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'website')]),
                  name: "website",
                  id: "website",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "website"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_first_name')]),
                  name: "contact_first_name",
                  id: "contact_first_name",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_first_name"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_last_name')]),
                  name: "contact_last_name",
                  id: "contact_last_name",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_last_name"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, { name: "contact_phone" }, {
                  default: _withCtx(({ meta: m }) => [
                    _createVNode(_component_InputMask, {
                      class: _normalizeClass(["form-control", m.valid === false && _ctx.isInvalid(errors, 'contact_phone')]),
                      modelValue: _ctx.phoneMaskedValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.phoneMaskedValue = $event)),
                      onChange: ($event: any) => (setFieldValue('contact_phone', _ctx.phoneMaskedValue)),
                      mask: "(999) 999-9999",
                      unmask: true,
                      type: "tel"
                    }, null, 8, ["class", "modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_phone"
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'contact_email')]),
                  name: "contact_email",
                  id: "contact_email",
                  type: "text"
                }, null, 8, ["class"]),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "contact_email"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errorMesage), 1))
                  : _createCommentVNode("", true),
                isSubmitting
                  ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  (!isSubmitting)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        disabled: !meta.dirty,
                        class: "btn btn-primary"
                      }, " Sign up ", 8, _hoisted_19))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"]),
      _hoisted_20
    ]),
    _: 1
  }))
}